import { render, staticRenderFns } from "./StatsAnnouncementModal.vue?vue&type=template&id=5850252e"
import script from "./StatsAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./StatsAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./StatsAnnouncementModal.vue?vue&type=style&index=0&id=5850252e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports